import {EntityApiService, ApiClientService} from '@dofleini/security';
import {FilterFactory} from '@dofleini/query-builder';

export const removeDateFilter = (params) => {
  if (params?.filters?.filters?.length) {
    const dateRange = params?.filters?.filters?.find((f) => {
      return f?.field === 'createdAt' || f?.field === 'date';
    });
    if (dateRange) {
      params.filters = FilterFactory.removeByFilter(params?.filters, dateRange);
    }
  }
  if (params?.filters) {
    params.filters = FilterFactory.removeByFilter(params?.filters, {field: 'createdAt', type: 'RANGE' });
    params.filters = FilterFactory.removeByFilter(params?.filters, {field: 'date', type: 'RANGE'});
  }
  return params;
};

export const removeServiceFilter = (params) => {
  if (params?.filters?.filters?.length) {
    const serviceFilter = params?.filters?.filters?.find((f) => {
      return f?.field === 'service';
    });
    if (serviceFilter) {
      params.filters = FilterFactory.removeByFilter(params?.filters, serviceFilter);
    }
  }
  if (params?.filters) {
    params.filters = FilterFactory.removeByFilter(params?.filters, {field: 'service', type: 'IN' });
  }
  return params;
};

export const area = (params) => {
  if (params?.filters?.filters?.length) {
    const area = params?.filters?.filters?.find((f) => {
      return f?.field === 'areas';
    })?.value;
    return {area};
  }
  if (params?.filters?.field === 'areas') {
    return {area: params?.filters?.value};
  }
  return {area: null};
};

export const areaAccess = (params) => {
  if (params?.filters?.filters?.length) {
    const areaAccess = params?.filters?.filters?.find((f) => {
      return f?.field === 'areaAccess';
    })?.value;
    return {areaAccess};
  }
  if (params?.filters?.field === 'areaAccess') {
    return {areaAccess: params?.filters?.value};
  }
  return {areaAccess: []};
};

export const categories = (params) => {
  if (params?.filters?.filters?.length) {
    const categories = params?.filters?.filters?.find((f) => {
      return f?.field === 'category';
    })?.value;
    return {categories};
  }
  if (params?.filters?.field === 'category') {
    return {categories: params?.filters?.value};
  }
  return {categories: []};
};

export const establishments = (params) => {
  if (params?.filters?.filters?.length) {
    const establishments = params?.filters?.filters?.find((f) => {
      return f?.field === 'establishments';
    })?.value;
    return {establishments};
  }
  if (params?.filters?.field === 'establishments') {
    return {establishments: params?.filters?.value};
  }
  return {establishments: []};
};

export const services = (params) => {
  if (params?.filters?.filters?.length) {
    const services = params?.filters?.filters?.find((f) => {
      return f?.field === 'service';
    })?.value;
    return Array.isArray(services) ? {services} : services ? {services: [services]} : {services: []};
  }
  if (params?.filters?.field === 'service') {
    return {services: Array.isArray(params?.filters?.value) ? params?.filters?.value : [params?.filters?.value] };
  }
  return {services: []};
};

export const date = (params) => {
  if (params?.filters?.filters?.length) {
    const dateRange = params?.filters?.filters?.find((f) => {
      return f?.field === 'createdAt' || f?.field === 'date';
    });
    return {date: {from: dateRange?.from, to: dateRange?.to}};
  }
  if (params?.filters?.field === 'createdAt' || params?.filters?.field === 'date' && params?.filters?.type === 'RANGE' ) {
    return {date: {from: params?.filters?.from, to: params?.filters.to}};
  }
  return {date: {}};
};

class ClientRegistersApiService extends EntityApiService {

  searchRegistersData = ({registerId, ...params}) => ApiClientService.post(this.getPath(`/${registerId}/facility-data`), params);

  searchPendingRegisters = (params) => ApiClientService.post(this.getPath('/pending/search'), {...area(params), ...establishments(params), ...removeDateFilter(params), size: 100});

  searchClosedRegisters = (params) => ApiClientService.post(this.getPath('/closed/search'), {...area(params), ...establishments(params), ...removeDateFilter(params), size: 100});

  searchCompletedRegisters = (params) => ApiClientService.post(this.getPath('/completed/search'), {...area(params),...establishments(params), ...removeDateFilter(params), size: 100});

  checkRegisterData = ({id, ...params}) => ApiClientService.post(this.getPath(`/${id}/answer/checkRegisterData`), params);

  updateRegister = ({id, ...params}) => ApiClientService.post(this.getPath(`/${id}/answer/add`), params);

  getClientRegistersMainData = (params) => {
    return ApiClientService.post('/ms-statistics/api/register-statistics/by-access-completion', {
      ...date(params), 
      ...establishments(params), 
      ...area(params),
      ...areaAccess(params),
      ...categories(params)}
    );
  }

  getClientRegistersDataByPeriod = (params) => {
    return ApiClientService.post('/ms-statistics/api/register-statistics/by-period-completion', {
      ...date(params),
      ...establishments(params),
      ...establishments(params),
      ...area(params),
      ...areaAccess(params),
      ...categories(params)
    });
  }

  updateFrequency = ({id, ...params}) => ApiClientService.patch(this.getPath(`/${id}/update-frequency`), params);

  getOne = function (id, config) {
    return ApiClientService.get(this.getPath('/client/' + id, config), config);
  };
}

export default new ClientRegistersApiService('/ms-registry/api/registers');
